<app-material>
    <div *ngIf="!isMobile" class="header" header>
        <app-display-label *ngIf="type=='lines'"
                           label="{{'lift-operator.incoming-tool-request.manufacturing-line' | translate}}"
                           [value]="selectedToolRequest.line?.name">
        </app-display-label>
        <app-display-label *ngIf="type=='lines'"
                           label="{{'lift-operator.incoming-tool-request.part-number'| translate}}"
                           [value]="getPartNumberName()">
        </app-display-label>
        <app-display-label *ngIf="type=='facilities'"
                           label="{{'lift-operator.incoming-tool-request.facility'| translate}}"
                           [value]="selectedToolRequest.facility?.name">
        </app-display-label>
        <app-display-label
            label="{{'lift-operator.incoming-tool-request.createdBy'| translate}}"
            [value]="selectedToolRequest.createdBy?.fullName"
        >
        </app-display-label>
        <app-display-label
            label="{{'lift-operator.incoming-tool-request.date' | translate}}"
            [value]="selectedToolRequest.createdDate"
        >
        </app-display-label>
        <app-display-label
            label="{{'lift-operator.incoming-tool-request.status' | translate}}"
            [value]="(selectedToolRequest.status | translate)"
        >
        </app-display-label>
    </div>
    <div class="content" body>
        <div *ngIf="isMobile" class="stats">
            <app-display-label *ngIf="type=='lines'"
                               label="{{'lift-operator.incoming-tool-request.manufacturing-line' | translate}}"
                               [value]="selectedToolRequest.line?.name">
            </app-display-label>
            <app-display-label *ngIf="type=='lines'"
                               label="{{'lift-operator.incoming-tool-request.part-number'| translate}}"
                               [value]="getPartNumberName()">
            </app-display-label>
            <app-display-label *ngIf="type=='facilities'"
                               label="{{'lift-operator.incoming-tool-request.facility'| translate}}"
                               [value]="selectedToolRequest.facility?.name">
            </app-display-label>
            <app-display-label
                label="{{'lift-operator.incoming-tool-request.createdBy'| translate}}"
                [value]="selectedToolRequest.createdBy?.fullName"
            >
            </app-display-label>
            <app-display-label
                label="{{'lift-operator.incoming-tool-request.date' | translate}}"
                [value]="selectedToolRequest.createdDate"
            >
            </app-display-label>
            <app-display-label
                label="{{'lift-operator.incoming-tool-request.status' | translate}}"
                [value]="(selectedToolRequest.status | translate)"
            >
            </app-display-label>
        </div>
        <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
        <app-tool-scan-tree *ngIf="!isLoading"
                            class="toolScanner"
                            [mode]="'displayGroupedByLocation'"
                            [isMaterial]="false"
                            [allExpanded]="true"
                            [isScanListenerActive]="false"
                            [items]="selectedTools">
        </app-tool-scan-tree>
    </div>
    <div class="footer" footer>
        <app-button type="primary" class="back" (click)="onBack()">{{
                'generic.buttons.back' |
                    translate
            }}
        </app-button>
        <app-button
            type="primary"
            [disabled]="isLoading"
            (click)="onProcessToolRequest()">
            {{ 'generic.buttons.approve' | translate }}
        </app-button>
    </div>
</app-material>

<app-confirmation-modal (scanEvent)="onConfirmProcess($event)"
                        (confirmEvent)="onConfirmProcess($event)"
                        (invalidBadge)="onInvalidBadge($event)"
                        [isConfirmationInProgress]="isConfirmationInProgress"
                        [confirmOnlyMode]="isMobile"
                        [title]="'lift-operator.incoming-tool-request.title' | translate"
                        [question]="'lift-operator.incoming-tool-request.question' | translate"
                        [message]="isMobile ? '' : 'lift-operator.incoming-tool-request.message' | translate"
                        [displayReasonMode]="false">
</app-confirmation-modal>

<app-logout-modal title="{{'lift-operator.incoming-tool-request.logoutTitle' | translate}}"
                  infoMessage="{{'lift-operator.incoming-tool-request.logoutText' | translate}}"
                  [redirectToHome]="false"
                  (continue)="onContinue()"
                  [timer]="10">
</app-logout-modal>
